export const getUniqueArrayByKey = <T = unknown>(array: T[], key: string) => [
  ...new Map(array.map(item => [item[key], item])).values(),
];

/**
 * Returns a new array with unique values
 * @public
 */
export const getUniqArray = <T = unknown>(array: T[]) =>
  Array.from(new Set(array));

export function alwaysArrayFrom<T>(maybeArray: T | T[]): T[] {
  if (Array.isArray(maybeArray)) {
    return maybeArray;
  }

  return [maybeArray];
}

export function chunkArray<T>(
  array: Array<T>,
  chunkSize: number,
): Array<Array<T>> {
  const copy = array.slice();

  if (chunkSize <= 0 || chunkSize >= copy.length) {
    return [copy];
  }

  const result: Array<Array<T>> = [];

  let chunk: Array<T>;

  while (copy.length > 0) {
    chunk = copy.splice(0, chunkSize);

    result.push(chunk);
  }

  return result;
}

export function findLastIndex<T>(
  array: Array<T>,
  predicate: (value: T, index: number, obj: T[]) => boolean,
): number {
  let l = array.length;

  while (l--) {
    if (predicate(array[l]!, l, array)) {
      return l;
    }
  }

  return -1;
}

export function intersection<T>(array1: T[], array2: T[]) {
  return array1.filter(value => array2.includes(value));
}

export async function mapArrayAsync<MapResult>(
  array: unknown[],
  mappingFunction: (value: unknown) => MapResult,
  chunkSize = 20,
) {
  const mappedArray: MapResult[] = [];

  for (let i = 0; i < array.length; i += chunkSize) {
    const chunk = array.slice(i, i + chunkSize);
    const mappedChunk = await Promise.all(chunk.map(mappingFunction));

    mappedArray.push(...mappedChunk);
  }

  return mappedArray;
}
